import React from 'react';
import Delivery from './Delivery';
import Rules from './Rules';

function DeliveryRules() {
   return (
      <div>
         <Delivery/>
         <Rules/>
      </div>
   );
}
export default DeliveryRules;